import { AxiosResponse } from 'axios';
import baseService from 'services/base-service';
import { SearchResult } from 'models/base-type';
import { IPatientProviderRequestModel } from 'models/patient';
import { ApiResponseModel } from 'models/api';
import { IPatientSettingModel } from 'models/patient/index';

const endPointBaseURL = `patients/PatientSetting`;

const getPatientSettingDetails = async (
    patientId: string,
    settingId: number,
    loginId: string,
): Promise<AxiosResponse<ApiResponseModel<IPatientSettingModel>>> =>
    baseService.get<ApiResponseModel<IPatientSettingModel>>(
        `${endPointBaseURL}/GetPatientSettingDetails?patientId=${patientId}&settingId=${settingId}&loginId=${loginId}`,
    );

const addEditPatientSetting = async (
    requestBody: IPatientProviderRequestModel,
    loginId: string,
): Promise<AxiosResponse<ApiResponseModel<SearchResult<number>>>> =>
    baseService.post<ApiResponseModel<SearchResult<number>>>(
        `${endPointBaseURL}/AddEditPatientSetting?loginId=${loginId}`,
        requestBody,
    );

export default {
    getPatientSettingDetails,
    addEditPatientSetting,
};
